import { reportInteraction } from '@grafana/runtime';

// AI Template Tracking
export const trackAITemplateButtonClick = () => {
  reportInteraction('grafana_alerting_ai_template_button_click');
};

export const trackAITemplateGeneration = (props: { success: boolean; error?: string }) => {
  reportInteraction('grafana_alerting_ai_template_generation', props);
};

export const trackAITemplateUsed = () => {
  reportInteraction('grafana_alerting_ai_template_used');
};

export const trackAITemplateCancelled = () => {
  reportInteraction('grafana_alerting_ai_template_cancelled');
};

// AI Triage Tracking
export const trackAITriageButtonClick = (provider: 'assistant' | 'llm') => {
  reportInteraction('grafana_alerting_ai_triage_button_click', { provider });
};
